import Index from '../components/IntegrationLog/Index.vue'

let routes = {
    path: '/integration-logs',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/integration-logs',
            name: 'Logs de Integrações',
            component: Index
        },
    ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/integration-logs.js